<template>
  <div class="alert-confirm">
    <div class="alert-mask" v-show="isShow">
      <div class="alert-dialog weui-animate-fade-in" v-if="type==='confirm'">
        <div class="alert-hd">
          {{title}}
          <span class="close" @click="close" v-if="hasClose"></span>
        </div>
        <div class="alert-by">
          <slot></slot>
        </div>
        <div class="alert-ft clearfix">
          <!-- <div class="cancle" @click="$emit('cancle')">{{cancleText}}</div> -->
          <div class="alert-ft" @click="$emit('next')">
            <div class="cancle_news">{{nextText}}</div>
          </div>
        </div>
      </div>

      <div class="alert-dialog weui-animate-fade-in has-bottom-line" v-if="type==='tips'">
        <div class="alert-hd">
          {{title}}
          <span class="close" @click="close" v-if="hasClose"></span>
        </div>
        <div class="alert-by">
          <slot></slot>
        </div>

        <div class="alert-ft" @click="$emit('next')">
          <div class="text">{{nextText}}</div>
        </div>
      </div>

   

      
      <!-- 删除订单start -->
      <div class="alert-dialog weui-animate-fade-in has-bottom-line" v-if="type==='deletipGood'">
        <div class="alert-hd takeDiv">
          <span class="takeTit">{{title}}</span>
        </div>

        <div class="alert-ft">
          <div class="cancleTake" @click="$emit('cancle')">{{cancleText}}</div>
          <div class="nextTake" @click="$emit('next')">{{nextText}}</div>
        </div>
      </div>
      <!-- 删除订单end -->

    </div>
  </div>
</template>

<script>
import * as api from "@/api";
// import JmmToast from "@/components/JmmToast";
export default {
  name: "msg-confirm",

  props: {
    type: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    cancleText: {
      type: String,
      default: ""
    },
    nextText: {
      type: String,
      default: ""
    },
  
   
  },
  data() {
    return {
      isShow: false,
    };
  },

  created() {},
  mounted() {},

  
  computed: {},
  //离开当前页面后执行
 
  methods: {
  
    close() {
      this.isShow = false;
     
    },
    open() {
      this.isShow = true;
    },
 
 
  }
};
</script>
<style scoped lang="stylus">

.alert-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  color: #333;
  background: rgba(0, 0, 0, 0.6);
  align-items: center;
  justify-content: center;
  display: -webkit-flex;

  .alert-dialog {
    background: #fff;
    border-radius: 0.12rem;
    padding-top: 0.3rem;
    box-sizing: border-box;
    width: calc(100% - 1.5rem);

    .alert-hd {
      font-size: 0.32rem;
      text-align: center;
      position: relative;
      padding-bottom: 0.3rem;

      .close {
        position: absolute;
        right: 37px;
        top: 37px;
        width: 33px;
        height: 33px;
        display: inline-block;
       
      }
    }

    .alert-by {
      padding: 0.25rem 0.6rem 0.3rem 0.6rem;
      font-size: 0.26rem;
      color: #666;
      line-height: 0.44rem;
      max-height: 7rem;
      overflow-y: auto;

      p.margin {
        margin-bottom: 0.14rem;
      }
    }

    .alert-ft {
      padding-bottom: 0.3rem;
      font-size: 0.28rem;

      .cancle {
        float: left;
        width: 2.4rem;
        height: 0.76rem;
        line-height: 0.76rem;
        background: #EEEEEE;
        color: #939393;
        text-align: center;
        border-radius: 0.38rem;
        margin-left: 0.35rem;
      }

      .cancle_news {
        width: 2.4rem;
        height: 0.76rem;
        line-height: 0.76rem;
        background: #FB4E4D;
        color: #fff;
        text-align: center;
        border-radius: 0.38rem;
        margin: 0 auto;
      }

      .next {
        float: right;
        width: 2.4rem;
        height: 0.76rem;
        line-height: 0.76rem;
        background: linear-gradient(90deg, rgba(253, 75, 23, 1) 0%, rgba(254, 101, 40, 1) 100%);
        color: #FFFFFF;
        text-align: center;
        border-radius: 0.38rem;
        margin-right: 0.35rem;
      }
    }
  }

  .alert-good {
    background: #fff;
    height: 941px;
    width: 100%;
    position: fixed;
    bottom: 0;

    .alert-goodDiv {
      width: calc(100% - 60px);
      margin: 70px auto;
      position: relative;

      .alert-good-Tit {
        height: 200px;

        img {
          width: 163px;
          height: 154px;
        }

        .alert-Rdiv {
          width: 470px;

          span {
            display: block;
            color: #212121;
            font-size: 34px;
          }

          b {
            display: block;
            color: #FE2E2E;
            font-size: 48px;
            padding-top: 40px;
          }
        }
      }

      .alert-good-Cont {
        height: 300px;
        overflow: auto;

        .categoryDiv {
          margin-bottom: 15px;

          h2 {
            color: #212121;
            font-size: 32px;
            font-weight: normal;
          }

          input {
            display: none;
          }

          input[type='radio']+label {
            /* 默认label的样式 */
            /* content: "\a0"; */
            width: 211px;
            height: 57px;
            background: rgba(221, 221, 221, 1);
            border-radius: 10px;
            display: inline-block;
            text-align: center;
            line-height: 57px;
            margin-top: 15px;
            margin-bottom: 15px;
            margin-right: 13px;
          }

          input[type='radio']:checked+label {
            /* 当点击label的时候背景颜色发生改变 */
            background-color: #FB4E4D;
            color: #fff;
          }

          .row {
            display: inline-block;
          }
        }
      }

      .alert-good-Cont::-webkit-scrollbar {
        width: 0px;
        display: none;
      }

      .alert-good-num {
        height: 200px;
        padding-top: 50px;

        span {
          color: #212121;
          font-size: 32px;
        }

        .alertNum {
          width: 246px;
          display: flex;

          span {
            flex: 1;
            width: 82px;
            background: #fff;
            border: 2px solid #ddd;
            text-align: center;

            img {
              width: 40px;
              height: 40px;
              display: inline-block;
              vertical-align: middle;
              margin-top: 8px;
            }
          }

          input {
            width: 82px;
            line-height: 62px;
            text-align: center;
            color: #FB4E4D;
          }
        }
      }

      .alert-good-btn {
        width: calc(100% - 160px);
        margin: 0 auto;
        height: 86px;
        line-height: 86px;
        background: #FB4E4D;
        color: #ffffff;
        font-size: 36px;
        border-radius: 43px;
        text-align: center;
      }

      .close {
        position: absolute;
        right: 0;
        top: 0;
        width: 33px;
        height: 33px;
        display: inline-block;
       
      }
    }
  }

  .alert-bussine {
    background: #fff;
    height: 1041px;
    width: 100%;
    position: fixed;
    bottom: 0;

    .alert-bussineDiv {
      width: 100%;
      height: 100%;

      .alert-First-Comule {
        width: 34%;
        float: left;
        height: 80%;
        overflow: auto;

        ul {
          width: calc(100% - 50px);
          margin: 0 auto;

          li {
            font-size: 30px;
            margin: 47px 10px;
            width: 100%;

            label {
              height: 60px;
              display: inline-block;
            }

            label span {
              padding-left: 25px;
              line-height: 60px;
            }

           

            input[type='checkbox'] {
              display: inline-block;
              opacity: 0;
              position: relative;
              left: -10px;
              top: 2px;
            }
          }
        }
      }

      .alert-Last-Comule {
        width: 65%;
        float: right;
        background: #EEEEEE;
        height: 100%;

        ul {
          width: calc(100% - 80px);
          margin: 0 auto;

          li {
            font-size: 30px;
            margin: 85px 10px;
            position: relative;

            

            label {
              height: 60px;
              display: inline-block;
            }

            label span {
              padding-left: 25px;
              line-height: 60px;
            }


            

            input[type='checkbox'] {
              display: inline-block;
              opacity: 0;
              position: absolute;
              left: -50px;
              top: -32px;
              width: 250px;
              height: 120px;
            }
          }
        }
      }

      .alert-catBussine-btn {
        position: fixed;
        width: calc(100% - 48px);
        bottom: 82px;
        left: 24px;
        height: 72px;
        font-size: 30px;
        text-align: center;

        .alert-Rest {
          width: calc(34% - 48px);
          margin-left: 10px;
          float: left;
          line-height: 72px;
          border: 2px solid #FB4E4D;
          border-radius: 36px;
          color: #FB4E4D;
        }

        .alert-Sure {
          width: calc(65% - 96px);
          margin-right: 35px;
          float: right;
          border: 1px solid red;
          line-height: 72px;
          border: 2px solid #FB4E4D;
          border-radius: 36px;
          color: #fff;
          background: #FB4E4D;
        }
      }
    }
  }

  .takeDiv img {
    width: 300px;
    height: 300px;
    text-align: center;
    display: block;
    margin: 0 auto;
  }

  .takeDiv .takeTit {
    width: 441px;
    color: #9494A0;
    font-size: 30px;
    line-height: 50px;
    display: block;
    margin: 0 auto;
  }

  .cancleTake {
    color: #9494A0;
    width: 50%;
    display: inline-block;
    float: left;
    text-align: center;
    border-right: 2px solid #9494A0;
    font-size: 36px;
  }

  .nextTake {
    color: #FB4E4D;
    width: 50%;
    display: inline-block;
    text-align: center;
    font-size: 36px;
  }

  .cancleWEIXIN {
    color: #9494A0;
    width: 100%;
    display: block;
    float: left;
    text-align: center;
    font-size: 25px;
    padding-bottom: 20px;
  }

  .nextWEIXIN {
    color: #FB4E4D;
    width: 100%;
    display: block;
    text-align: center;
    font-size: 25px;
  }

  /* 有上面的线 */
  .has-bottom-line {
    .alert-ft {
      border-top: 1px solid #E0E0E0;
      font-size: 0.28rem;
      padding: 0.3rem;

      .text {
        height: 0.76rem;
        line-height: 0.76rem;
        background: linear-gradient(90deg, rgba(253, 75, 23, 1) 0%, rgba(254, 101, 40, 1) 100%);
        border-radius: 0.38rem;
        margin: 0 0.4rem;
        color: #FFFFFF;
        text-align: center;
        font-size: 0.28rem;
      }
    }
  }
}










</style>



// WEBPACK FOOTER //
// src/components/Alert.vue